export function parseInternalRedirect(value: unknown) {
	if (typeof value !== "string") return null;
	if (!value.startsWith("/") || value.startsWith("//")) return null;
	return value;
}

export function parseChoosePlanRedirect(value: unknown) {
	let redirect = parseInternalRedirect(value);
	for (let depth = 0; depth < 10 && redirect; depth += 1) {
		const url = new URL(redirect, "https://agentreacher.local");
		if (url.pathname !== "/choose-plan") return redirect;
		redirect = parseInternalRedirect(url.searchParams.get("redirect"));
	}
	return null;
}

export function buildChoosePlanUrl(redirectValue: unknown) {
	const redirect = parseChoosePlanRedirect(redirectValue);
	if (!redirect) return "/choose-plan";

	const search = new URLSearchParams({ redirect });
	return `/choose-plan?${search.toString()}`;
}

export function isCheckoutClaimRedirect(value: unknown) {
	const redirect = parseInternalRedirect(value);
	if (!redirect) return false;

	const url = new URL(redirect, "https://agentreacher.local");
	return (
		url.pathname === "/upgrade-success" &&
		url.searchParams.has("checkoutSessionId") &&
		url.searchParams.has("claimToken")
	);
}

export function buildPostAuthUrl(redirectValue: unknown) {
	const redirect = parseInternalRedirect(redirectValue);
	if (isCheckoutClaimRedirect(redirect)) return redirect as string;
	return buildChoosePlanUrl(redirectValue);
}
